export function getLocalStorageItem<T>(keyName: string): T | undefined {
  try {
    const item = window && window.localStorage.getItem(keyName);
    return item && JSON.parse(item);
  } catch (e) {}
}

export function setLocalStorageItem<T>(keyName: string, value: T): void {
  try {
    window && window.localStorage.setItem(keyName, JSON.stringify(value));
  } catch (e) {}
}
